import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Image } from 'components/core/Image';

const SIZE_DIMENSIONS = {
    small: { width: '320', height: '180' },
    medium: { width: '480', height: '270' },
    large: { width: '640', height: '360' },
    xlarge: { width: '800', height: '450' },
};

const WEBP_CONVERTIBLE_EXT = /\.(jpe?g|png)(?=$|[?#])/i;

function getWebpSrc(src) {
    if (!src) {
        return null;
    }
    if (!WEBP_CONVERTIBLE_EXT.test(src)) {
        return null;
    }
    return src.replace(WEBP_CONVERTIBLE_EXT, '.webp');
}

function FacilityImage({ src: srcProp, size, lazyLoad, ...imageProps }) {
    const cloudfrontUrl = useSelector((state) => state.app.cloudfrontUrl);

    const resolvedSize = size || 'small';
    const dimensions = SIZE_DIMENSIONS[resolvedSize] || SIZE_DIMENSIONS.small;
    const filename = srcProp || 'default-sparefoot-photo.jpg';
    const baseSrc = `${cloudfrontUrl}/${resolvedSize}-compress/${filename}`;
    const webpSrc = getWebpSrc(baseSrc);

    // Skip webp when lazyLoad=false (e.g., map popups) to avoid 403 errors
    const useWebp = lazyLoad !== false && webpSrc;

    return (
        <picture>
            {useWebp && <source srcSet={webpSrc} type="image/webp" />}
            <Image
                src={baseSrc}
                lazyLoad={lazyLoad}
                className="facility-image"
                width={dimensions.width}
                height={dimensions.height}
                {...imageProps}
            />
        </picture>
    );
}

FacilityImage.propTypes = {
    src: PropTypes.string,
    size: PropTypes.string,
    lazyLoad: PropTypes.bool,
};

export default FacilityImage;
